/////////////////////////////////////////////////////////
// Note: Bootstrap alerts are confusing and infuriating.
// Custom alert code ++;
/////////////////////////////////////////////////////////

;(function($, undefined){
    'use strict';

    var rnn = window.rnn,
        $window = $(window),
        cachedAlert;


    /////////////////////
    // Create New Alert
    /////////////////////
    function createAlert(type){

        //Cache the result so its faster next time

        var alert = (cachedAlert = cachedAlert || (function(){
            cachedAlert = $($.el.div({'class':'alert clear'},
                $.el.button({'class':'close', 'data-dismiss':'alert'},'×'),
                $.el.h4({'class':'alert-heading'})
            ));
            return cachedAlert;
        }())).clone().hide();

        // I'M SORRY JESUS BUT BOOTSTRAP3 MADE ME DO IT
        if (type === 'error') {
            type += ' alert-danger';
        }

        return alert.addClass("alert-" + type);
    }

    ////////////////////////
    // Stick Alert to Top
    ////////////////////////
    function stick_alert(alert) {
        // if the element is not present assume not sticky
        if ($('.alertWrapper').length == 0){
            return;
        }
        var $alert = $(alert),
            alertWrapperTop = $('.alertWrapper').offset().top,
            $nav = $('.desktopNav'),
            navHeight = ($nav.length && $nav.find('.navWrapper').length && $nav.find('.navWrapper').outerHeight()) || 0,
            navBottom = ($nav.length && $nav.offset().top + navHeight) || 0,
            navStuck = ($nav.length && $nav.hasClass('stuck')) || false;

        if (!$alert) {
            return;
        }

        if (alertWrapperTop < $window.scrollTop() || (navStuck && alertWrapperTop < navBottom)) {
            $alert.addClass('stuck');
        } else {
            $alert.removeClass('stuck');
        }

        if (navStuck) {
            $alert.css('top', navHeight);
        }

    }


    /////////////////////
    // Show Alert
    /////////////////////
    function show(){

        var options,
            parent = arguments[0];

        //No message/options? do nothing.
        if(!arguments[1]){
            return;
        }

        //Passed options
        if(typeof arguments[1] === 'object'){
            options = arguments[1];
        }else{ //passed parameters
            options = {
                message: arguments[1],
                heading: arguments[2],
                autoHide: arguments[3],
                type: 'info',
                extraClass: ''
            };
        }

        var $newAlert = createAlert(options.type),
            $alertHeading = $newAlert.find(".alert-heading");

        if (options.stick || false) {
            //Sticky to top of page
            stick_alert($newAlert);
            $window.on('scroll resize', function(){
                stick_alert($newAlert);
            });
        }

        if (options.heading) {
            $alertHeading.text(options.heading || "");
        } else {
            $alertHeading.hide();
        }
        $newAlert.append(options.message || "");

        if(options.prepend){
            $(parent).prepend($newAlert);
        }else{
            $(parent).append($newAlert);
        }

        if (options.extraClass) {
            $newAlert.addClass(options.extraClass);
        }

        $newAlert.delay(2).slideDown(200);
        if(options.autoHide){
            $newAlert.animate({opacity: 0}, options.autoHide, function(){
                $newAlert.slideUp(200, function(){
                    $newAlert.remove();
                });
            });
        }

        return $newAlert;
    }


    /////////////////////
    // Init Alerts
    /////////////////////
    function initAlerts(){
        $(document).on("click", ".alert .close", function(event){
            var closeEvent = $.Event('closeAlert');
            closeEvent.target = this;

            $(this).trigger(closeEvent);
        }).on("closeAlert", ".alert", function(event){
            event.stopPropagation();
            $(event.target).closest('.alert').stop().hide(200, function(){
                $(this).remove();
            });
        });
    }


    rnn.modules.register("alert", {
        init: initAlerts,
        show: show
    });

})(jQuery);
